import React, {useState, useRef, useContext} from 'react';
import {Container, Row, Col} from 'reactstrap';
import { Formik } from 'formik';
import classes from './Login.module.css';
import {login, saveToken} from "../../../helpers/Token.helper";
import GlobalContext from "../../../context/GlobalContext";
import { getProfile } from '../../../helpers/Profile.helper';
import {useHistory} from "react-router-dom";

const Login = () => {

    let history = useHistory();

    const { setToken, setLoading, setMentorProfile } = useContext(GlobalContext);

    const [isHidden, setIsHidden] = useState(true);
    const email = useRef();
    const pass = useRef();
    const icon = useRef();

    const showHidePassword = () => {
        if(!isHidden){
            pass.current.setAttribute('type', 'password');
            icon.current.classList.remove('fa-eye-slash');
            icon.current.classList.add('fa-eye');
            setIsHidden(true);
        }else{
            pass.current.setAttribute('type', 'text');
            icon.current.classList.remove('fa-eye');
            icon.current.classList.add('fa-eye-slash');
            setIsHidden(false);
        }
    }

    const onFocus = elem => {
        document.getElementById('error').style.display = 'none';
        document.getElementById('error').innerText = '';
        const text = elem.current.closest('.input-container').children[0];
        text.setAttribute('style', 'top: 0; font-size: .7em; background-color: white;');
    }

    const onBlur = elem => {
        const value = elem.current.value;
        if(!value.length > 0){
            const text = elem.current.closest('.input-container').children[0];
            text.removeAttribute('style');
        };
    }

    return(
        <Container className={classes.container}>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Iniciar sesión</h1>
                        <span>Inicia sesión para comenzar a buscar mentorías</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{justifyContent: "center", margin: "50px 0"}}>
                  <Formik
                    initialValues={{ email: null, password: null }}
                    validate={values => {
                      const errors = {};
                      if (!values.email) {
                          errors.email = 'Requerido';
                      } else if (
                          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                      ) {
                          errors.email = 'Invalid email address';
                      }
                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setLoading(true);
                        login({user: values.email, password: values.password}).then(async token => {
                            if(token.token){
                                try{
                                    document.getElementById('error').style.display = 'none';
                                    setToken(token.token); //globalContext
                                    saveToken(token.token); //localstorage
                                    const profile = await getProfile();
                                    setMentorProfile(profile);
                                    history.push(`/mi-perfil`);
                                }catch(ex){
                                    console.error(ex);
                                    values.email = '';
                                    values.password = '';
                                    document.getElementById('error').style.display = 'block';
                                    document.getElementById('error').innerText = 'Ha ocurrido un error, favor de intentar de nuevo.';
                                }
                            }else if(token.error){
                                console.error(token.error);
                                values.email = '';
                                values.password = '';
                                document.getElementById('error').style.display = 'block';
                                document.getElementById('error').innerText = token.error;
                                // alert(token.error);
                            }
                            setLoading(false);
                            setSubmitting(false);
                        });
                    }}
                  >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                      <form className={classes.form} onSubmit={handleSubmit}>
                        <div className={"input-container " + classes.inputContainer}>
                          <label className={classes.text} htmlFor="email">Correo electrónico</label>
                          <input type="email" name="email" id="email" className={classes.input} onFocus={()=>{onFocus(email)}} onBlur={()=>{onBlur(email)}} ref={email} onChange={handleChange} value={values.email}/>
                        </div>
                        <div className={"input-container " + classes.inputContainer}>
                          <label className={classes.text} htmlFor="pass">Contraseña</label>
                          <span>
                                <input type="password" name="password" id="pass" className={classes.input} onFocus={()=>{onFocus(pass)}} onBlur={()=>{onBlur(pass)}} ref={pass} onChange={handleChange} value={values.password}/>
                                <span className={classes.icon} onClick={showHidePassword}><i className="fas fa-eye" ref={icon}></i></span>
                            </span>
                        </div>
                        <span id='error' style={{color: 'red', display: 'none', fontSize: '10px'}}></span>
                        <input type="submit" className={classes.submit} value="Iniciar sesión" disabled={isSubmitting} />
                      </form>
                    )}
                  </Formik>
                </Col>
            </Row>
        </Container>
    )
}
export default Login;
